export interface AwardedItem {
  id: string;
  caseNumber: string;
  court: string;
  location: string;
  propertyType: string;
  appraisedValue: number;
  minimumPrice: number;
  auctionDate: string;
  failureCount: number;
  exclusiveArea: number;
  buildingAge: number;
  actualWinningBid: number;
  bidderCount: number;
  bidCompetitionRate: string;
  expertGrade: "적극추천" | "추천" | "관망";
  expertSummary: string;
  expertFullAnalysis: string;
  keyLessons: string[];
  profitBreakdown: {
    winningBid: number;
    acquisitionTax: number;
    evictionCost: number;
    renovationCost: number;
    brokerageFee: number;
    totalCost: number;
    estimatedMarketPrice: number;
    estimatedProfit: number;
    profitRate: number;
  };
  regionalContext: string;
  similarCurrentListings: {
    location: string;
    minimumPrice: number;
    auctionDate: string;
  }[];
  imagePrompt: string;
  region: string;
  imageUrl: string;
}

export const awardedItems: AwardedItem[] = [
  {
    id: "a1",
    caseNumber: "2023타경61234",
    court: "서울중앙지방법원",
    location: "서울 강남구 역삼동",
    propertyType: "아파트",
    appraisedValue: 850000000,
    minimumPrice: 595000000,
    auctionDate: "2025-11-15",
    failureCount: 1,
    exclusiveArea: 84,
    buildingAge: 15,
    actualWinningBid: 720000000,
    bidderCount: 8,
    bidCompetitionRate: "8:1",
    expertGrade: "적극추천",
    expertSummary: "감정가 대비 85%에 낙찰. 인근 시세 9.5억 대비 24% 할인된 가격으로, 단기 차익 실현 가능성이 매우 높았던 물건입니다.",
    expertFullAnalysis: "역삼동 래미안 단지 내 물건으로, 1회 유찰 후 최저가 5.95억에 나왔으나 입찰 경쟁이 치열했습니다. 최종 낙찰가 7.2억은 감정가 대비 84.7% 수준으로, 인근 동일 평형 실거래가(9.3~9.8억)를 고려하면 약 2.4억의 시세차익이 기대되는 우량 물건이었습니다.\n\n권리관계는 말소기준권리 1순위로 깔끔했고, 임차인도 없어 명도 리스크가 전무했습니다. 다만 건물 연식 15년으로 리모델링 비용 약 3,000만원이 소요될 것으로 판단되어 이를 감안한 실질 수익률은 약 21%로 추정됩니다.\n\n경매 당시 8명의 응찰자가 몰린 것은 이 물건의 투자 가치를 방증합니다. 특히 역삼동은 직주근접 수요가 탄탄해 매도 기간이 짧다는 점도 강점이었습니다.",
    keyLessons: [
      "강남권은 1회 유찰 물건도 경쟁이 치열하니 최저가의 115~125%까지 입찰가를 준비해야 함",
      "감정가의 85% 이하 낙찰은 실거래가 대비 충분한 마진을 확보할 수 있는 구간",
      "임차인 없는 물건은 명도 리스크가 없어 초보자도 안전하게 접근 가능",
    ],
    profitBreakdown: {
      winningBid: 720000000,
      acquisitionTax: 33120000,
      evictionCost: 0,
      renovationCost: 30000000,
      brokerageFee: 3800000,
      totalCost: 787320000,
      estimatedMarketPrice: 950000000,
      estimatedProfit: 162680000,
      profitRate: 20.7,
    },
    regionalContext: "강남구 역삼동은 2024년 하반기부터 거래량이 회복세를 보이며 아파트 매매가가 전년 대비 약 5% 상승했습니다. 테헤란로 인근 직장인 수요가 꾸준하고, 강남권 재건축 호재로 중장기 가격 상승이 기대되는 지역입니다. 특히 84㎡ 국민평형은 실수요와 투자수요가 모두 몰리는 평형대로, 경매 시장에서도 인기가 높습니다.",
    similarCurrentListings: [
      { location: "서울 강남구 역삼동", minimumPrice: 620000000, auctionDate: "2026-08-20" },
      { location: "서울 강남구 도곡동", minimumPrice: 580000000, auctionDate: "2026-09-05" },
    ],
    imagePrompt: "modern luxury apartment complex in Yeoksam-dong Gangnam Seoul Korea, high-rise residential building with clean contemporary architecture, bright sunny daytime, premium real estate photography, sophisticated urban lifestyle, professional composition with soft natural lighting and warm tones, simple elegant background",
    region: "서울",
    imageUrl: "https://img.echotwin.kr/kangstudy/49afbd2995bdc205.jpg",
  },
  {
    id: "a2",
    caseNumber: "2023타경78521",
    court: "수원지방법원 성남지원",
    location: "경기 성남시 분당구 정자동",
    propertyType: "아파트",
    appraisedValue: 620000000,
    minimumPrice: 434000000,
    auctionDate: "2025-12-03",
    failureCount: 1,
    exclusiveArea: 79,
    buildingAge: 22,
    actualWinningBid: 510000000,
    bidderCount: 5,
    bidCompetitionRate: "5:1",
    expertGrade: "추천",
    expertSummary: "감정가 대비 82%에 낙찰. 분당 신도시 입지와 GTX 호재를 고려하면 중장기 투자 가치가 높았던 물건입니다.",
    expertFullAnalysis: "분당 정자동의 구축 아파트로, 건물 연식 22년으로 다소 노후되었으나 분당선·신분당선 더블 역세권에 GTX-A 노선 개통 호재가 예정된 지역입니다. 1회 유찰로 최저가 4.34억까지 내려왔고, 최종 5.1억에 낙찰되었습니다.\n\n권리분석 결과 근저당권 말소는 문제없었으나, 선순위 임차인 1명(보증금 1.5억)이 있어 배당에서 후순위로 밀릴 가능성이 존재했습니다. 다행히 낙찰자가 인수하지 않아도 되는 말소기준권리였습니다.\n\n실거래가 6.5~7억 수준을 감안하면 약 1.5억의 시세차익이 가능하나, 리모델링 비용 4,000만원과 취득세 등을 제하면 순수익은 약 9,000만원(수익률 약 16%)으로 추정됩니다. 5명이 경쟁한 점을 볼 때 시장에서도 적정 가격대였던 것으로 분석됩니다.",
    keyLessons: [
      "GTX 등 교통 호재가 예정된 지역은 경매 낙찰가도 그만큼 높게 형성됨",
      "건물 노후도가 높으면 리모델링 비용을 보수적으로 잡아야 실제 수익률이 왜곡되지 않음",
      "임차인이 있는 물건은 반드시 배당순위를 확인하고, 인수 여부를 사전에 검토해야 함",
    ],
    profitBreakdown: {
      winningBid: 510000000,
      acquisitionTax: 23460000,
      evictionCost: 5000000,
      renovationCost: 40000000,
      brokerageFee: 3000000,
      totalCost: 581460000,
      estimatedMarketPrice: 680000000,
      estimatedProfit: 98540000,
      profitRate: 16.9,
    },
    regionalContext: "분당구는 1기 신도시로 재건축 연한이 도래하는 단지가 많아 중장기적인 가치 상승이 기대됩니다. 특히 GTX-A 노선(수서~동탄) 개통으로 서울 접근성이 크게 개선될 예정이어서, 정자동 일대는 강남 접근성 프리미엄이 반영되고 있습니다. 다만 구축 아파트의 경우 리모델링/재건축 이슈가 복잡하므로 사전 조사가 필수입니다.",
    similarCurrentListings: [
      { location: "경기 성남시 분당구 서현동", minimumPrice: 450000000, auctionDate: "2026-08-28" },
      { location: "경기 성남시 분당구 수내동", minimumPrice: 410000000, auctionDate: "2026-09-12" },
    ],
    imagePrompt: "residential apartment complex in Jeongja-dong Bundang Seongnam Korea, tree-lined streets with modern mid-rise buildings, clean suburban atmosphere, professional real estate photography, bright natural daylight, warm neighborhood feeling, organized urban planning aesthetic",
    region: "경기",
    imageUrl: "https://img.echotwin.kr/kangstudy/7f27b79dd7a44e6b.jpg",
  },
  {
    id: "a3",
    caseNumber: "2023타경89341",
    court: "인천지방법원",
    location: "인천 연수구 송도동",
    propertyType: "오피스텔",
    appraisedValue: 280000000,
    minimumPrice: 196000000,
    auctionDate: "2026-01-20",
    failureCount: 1,
    exclusiveArea: 42,
    buildingAge: 8,
    actualWinningBid: 235000000,
    bidderCount: 3,
    bidCompetitionRate: "3:1",
    expertGrade: "추천",
    expertSummary: "송도 국제도시 내 오피스텔로, 월세 수익률이 높고 공실 리스크가 낮아 임대 수익형 투자에 적합한 물건이었습니다.",
    expertFullAnalysis: "송도동의 주거용 오피스텔로, 1회 유찰로 최저가 1.96억에 나왔고 3명이 경쟁하여 2.35억에 낙찰되었습니다. 인근 동일 평형 실거래가 2.7~3억 수준을 감안하면 매매차익도 가능하지만, 이 물건의 진짜 가치는 월세 수익에 있습니다.\n\n송도는 외국계 기업과 대학이 밀집해 있어 1인 가구 임대 수요가 풍부합니다. 월세 80~100만원 수준의 임대료를 받을 수 있어 연 4.5% 이상의 임대 수익률이 기대됩니다. 권리관계도 깨끗했고, 건물 연식 8년으로 시설 상태도 양호했습니다.\n\n3명의 응찰로 경쟁은 비교적 낮은 편이었는데, 이는 오피스텔 경매에 대한 일반인의 접근성이 낮기 때문으로 분석됩니다. 오히려 이런 틈새 시장에서 좋은 물건을 발견할 확률이 높다는 점을 보여주는 사례입니다.",
    keyLessons: [
      "오피스텔 경매는 아파트에 비해 경쟁이 덜해 수익성 좋은 물건을 발견할 확률이 높음",
      "임대 수익형 물건은 매매차익뿐 아니라 월세 현금흐름도 함께 고려해야 함",
      "대학가·업무지구 인근 오피스텔은 공실 리스크가 낮아 안정적인 투자처",
    ],
    profitBreakdown: {
      winningBid: 235000000,
      acquisitionTax: 10810000,
      evictionCost: 0,
      renovationCost: 8000000,
      brokerageFee: 2000000,
      totalCost: 255810000,
      estimatedMarketPrice: 285000000,
      estimatedProfit: 29190000,
      profitRate: 11.4,
    },
    regionalContext: "송도국제도시는 인천경제자유구역의 핵심 지역으로, 바이오·IT 기업과 연세대·인천대 등 교육기관이 밀집해 있습니다. 1인 가구 비중이 높고 외국인 체류자도 많아 오피스텔 임대 수요가 꾸준합니다. 다만 신규 공급도 활발하므로 입지 선별이 중요하며, 지하철역 도보권 물건이 프리미엄이 있습니다.",
    similarCurrentListings: [
      { location: "인천 연수구 송도동", minimumPrice: 210000000, auctionDate: "2026-08-18" },
      { location: "인천 연수구 동춘동", minimumPrice: 180000000, auctionDate: "2026-09-02" },
    ],
    imagePrompt: "modern officetel building in Songdo International City Incheon Korea, sleek contemporary architecture with glass facade, clean urban setting, professional real estate photography, bright coastal daylight, international business district atmosphere, sophisticated cityscape",
    region: "인천",
    imageUrl: "https://img.echotwin.kr/kangstudy/42d06bca18f583be.jpg",
  },
  {
    id: "a4",
    caseNumber: "2024타경10234",
    court: "대전지방법원",
    location: "대전 유성구 도룡동",
    propertyType: "아파트",
    appraisedValue: 420000000,
    minimumPrice: 294000000,
    auctionDate: "2026-02-14",
    failureCount: 1,
    exclusiveArea: 72,
    buildingAge: 18,
    actualWinningBid: 340000000,
    bidderCount: 6,
    bidCompetitionRate: "6:1",
    expertGrade: "적극추천",
    expertSummary: "대덕연구단지 직장인 수요가 탄탄한 도룡동 아파트. 감정가 대비 81% 낙찰로 가격 메리트가 뚜렷했고, 실거주·임대 모두 강점이 있는 물건입니다.",
    expertFullAnalysis: "대전 유성구 도룡동은 대덕연구단지와 KAIST, 충남대가 인접해 있어 연구원·교직원·대학원생 등 안정적인 주거 수요가 뒷받침되는 지역입니다. 1회 유찰로 최저가 2.94억까지 내려왔고, 6명이 경쟁하여 3.4억에 최종 낙찰되었습니다.\n\n권리관계는 근저당권 말소만 하면 되는 단순 구조였고, 임차인도 없어 인도명령 리스크가 없었습니다. 실거래가 4.2~4.5억을 감안하면 약 1억의 시세차익이 가능한 물건이었습니다.\n\n특히 이 물건은 대전 지하철 1호선 도보 5분 거리로, 직장인 임차 수요가 매우 높은 입지입니다. 경쟁률 6:1은 이 지역 경매 물건 중에서도 높은 편으로, 투자자들이 이 물건의 가치를 제대로 인식하고 있었다는 증거입니다.",
    keyLessons: [
      "연구단지·대학 인근 주거지는 경기 변동에 덜 민감한 안정적인 임대 수요가 뒷받침됨",
      "지방 광역시라도 입지가 좋은 물건은 수도권 못지않은 경쟁률을 보임",
      "도보 5분 이내 지하철 역세권은 임대와 매도 모두에서 강력한 프리미엄",
    ],
    profitBreakdown: {
      winningBid: 340000000,
      acquisitionTax: 15640000,
      evictionCost: 0,
      renovationCost: 15000000,
      brokerageFee: 2500000,
      totalCost: 373140000,
      estimatedMarketPrice: 430000000,
      estimatedProfit: 56860000,
      profitRate: 15.2,
    },
    regionalContext: "대전 유성구는 정부출연연구기관과 과학기술원이 밀집한 연구도시로, 고학력·고소득 인구 비중이 높습니다. 도룡동은 유성구 내에서도 주거 선호도가 높은 지역으로, 엑스포과학공원과 인접하고 둔산신도시 접근성도 좋습니다. 최근 세종시와의 연계 개발로 중장기 성장성이 주목받고 있습니다.",
    similarCurrentListings: [
      { location: "대전 유성구 도룡동", minimumPrice: 310000000, auctionDate: "2026-09-01" },
      { location: "대전 유성구 신성동", minimumPrice: 280000000, auctionDate: "2026-08-25" },
    ],
    imagePrompt: "mid-rise apartment complex in Doryong-dong Yuseong-gu Daejeon Korea, research district residential area, clean modern Korean apartment buildings with mountain backdrop, bright daytime professional real estate photography, peaceful academic neighborhood atmosphere, warm natural lighting",
    region: "대전",
    imageUrl: "https://img.echotwin.kr/kangstudy/6011dbfc2ef15a28.jpg",
  },
  {
    id: "a5",
    caseNumber: "2024타경25678",
    court: "부산지방법원",
    location: "부산 수영구 광안동",
    propertyType: "아파트",
    appraisedValue: 510000000,
    minimumPrice: 357000000,
    auctionDate: "2026-03-08",
    failureCount: 1,
    exclusiveArea: 77,
    buildingAge: 20,
    actualWinningBid: 400000000,
    bidderCount: 4,
    bidCompetitionRate: "4:1",
    expertGrade: "추천",
    expertSummary: "광안리 해변 인근 아파트로, 해양 조망 프리미엄과 관광 인프라를 갖춘 입지. 관망세 속에서도 적정 가격에 낙찰된 균형 잡힌 물건입니다.",
    expertFullAnalysis: "부산 수영구 광안동은 광안리 해변과 금련산을 동시에 끼고 있는 부산의 대표 주거지역입니다. 이 물건은 1회 유찰로 최저가 3.57억, 4명이 경쟁하여 최종 4억에 낙찰되었습니다.\n\n권리분석 결과 선순위 근저당권 말소는 문제없었으나, 임차인 1명(보증금 8,000만원)의 배당요구가 있어 이를 확인할 필요가 있었습니다. 실제 배당에서 임차인은 후순위로 밀려 낙찰자에게 넘어오지 않아 리스크는 해소되었습니다.\n\n실거래가 4.8~5.2억 수준으로, 시세차익 약 9,000만원이 예상됩니다. 다만 부산은 2025년 하반기 이후 부동산 시장이 다소 주춤한 상태라, 매도 타이밍을 신중하게 잡을 필요가 있습니다. 관광 인프라를 활용한 단기 임대(에어비앤비 등)도 수익성 있는 옵션으로 검토할 만합니다.",
    keyLessons: [
      "해변이나 관광지 인근 물건은 일반 주거지 대비 프리미엄이 있지만, 시장 변동성도 함께 고려해야 함",
      "임차인의 배당요구가 있어도 말소기준권리보다 후순위면 낙찰자가 인수하지 않음",
      "지방 광역시 물건은 매도 타이밍이 중요하므로 지역 시장 사이클을 잘 파악할 것",
    ],
    profitBreakdown: {
      winningBid: 400000000,
      acquisitionTax: 18400000,
      evictionCost: 3000000,
      renovationCost: 20000000,
      brokerageFee: 2800000,
      totalCost: 444200000,
      estimatedMarketPrice: 500000000,
      estimatedProfit: 55800000,
      profitRate: 12.6,
    },
    regionalContext: "부산 수영구는 광안리 해변을 중심으로 한 주거·관광 복합 지역입니다. 해운대와 남천동을 잇는 해안 벨트의 중간에 위치해 있고, 수영강과 금련산 등 자연환경이 우수합니다. 2025년부터는 전국적인 부동산 조정기 영향으로 거래량이 감소했으나, 광안대교·마린시티 등 랜드마크 인프라는 여전히 지역 가치를 지지하고 있습니다.",
    similarCurrentListings: [
      { location: "부산 수영구 광안동", minimumPrice: 370000000, auctionDate: "2026-08-22" },
      { location: "부산 수영구 남천동", minimumPrice: 420000000, auctionDate: "2026-09-10" },
    ],
    imagePrompt: "apartment buildings near Gwangalli Beach Busan Korea, ocean view residential area with Gwangan Bridge in distance, clean coastal urban landscape, professional real estate photography, bright seaside atmosphere with blue sky, modern Korean residential architecture, warm sunlight reflecting on buildings",
    region: "부산",
    imageUrl: "https://img.echotwin.kr/kangstudy/e8e9c4586b0141cb.jpg",
  },
  {
    id: "a6",
    caseNumber: "2024타경34129",
    court: "서울서부지방법원",
    location: "서울 마포구 합정동",
    propertyType: "다세대",
    appraisedValue: 380000000,
    minimumPrice: 266000000,
    auctionDate: "2026-04-22",
    failureCount: 1,
    exclusiveArea: 55,
    buildingAge: 16,
    actualWinningBid: 310000000,
    bidderCount: 7,
    bidCompetitionRate: "7:1",
    expertGrade: "적극추천",
    expertSummary: "합정동 다세대주택으로, 홍대·합정 상권과의 근접성이 최대 강점. 감정가 대비 81.6% 낙찰로 높은 가격 메리트를 보인 알짜 물건입니다.",
    expertFullAnalysis: "서울 마포구 합정동은 홍대와 합정역 상권이 맞닿아 있는 지역으로, 2030 직장인과 프리랜서의 주거 선호도가 매우 높은 곳입니다. 다세대주택이라는 점에서 아파트에 비해 진입장벽이 낮았고, 1회 유찰 후 최저가 2.66억에 나왔으나 7명이 경쟁하여 3.1억에 낙찰되었습니다.\n\n권리관계는 근저당권 말소만 하면 되는 단순 구조였고, 임차인도 없었습니다. 실거래가 3.6~3.9억 수준을 감안하면 5,000~8,000만원의 시세차익이 가능한 물건입니다. 특히 합정동은 전세가율이 높아 갭투자로 접근하기에도 좋은 조건이었습니다.\n\n7명의 응찰자가 몰린 것은 이 물건이 '작지만 알짜'라는 시장의 평가를 보여줍니다. 총 투자금 3.4억(취득세·리모델링 포함)으로 서울 핵심 입지의 주택을 확보할 수 있다는 점이 매력적이었습니다.",
    keyLessons: [
      "다세대·연립주택은 아파트보다 경매 진입장벽이 낮아 첫 투자로 적합할 수 있음",
      "상권·교통이 좋은 지역의 소형 주택은 전월세 수요가 탄탄해 갭투자 전략이 유효",
      "서울 핵심 지역은 건물 유형보다 입지가 투자 가치를 결정하는 핵심 요소",
    ],
    profitBreakdown: {
      winningBid: 310000000,
      acquisitionTax: 14260000,
      evictionCost: 0,
      renovationCost: 12000000,
      brokerageFee: 2200000,
      totalCost: 338460000,
      estimatedMarketPrice: 375000000,
      estimatedProfit: 36540000,
      profitRate: 10.8,
    },
    regionalContext: "마포구 합정동은 홍대입구역(2호선)·합정역(2·6호선)의 더블 역세권으로, 서울 서부의 핵심 상업·주거 지역입니다. 카페·레스토랑·디자인 스튜디오 등이 밀집해 있고, 당인리 문화창작발전소 등 문화 인프라도 풍부합니다. 최근에는 합정역 인근 오피스텔과 소형 주택의 수요가 꾸준히 증가하는 추세로, 중소형 평형의 투자 가치가 재평가되고 있습니다.",
    similarCurrentListings: [
      { location: "서울 마포구 합정동", minimumPrice: 280000000, auctionDate: "2026-08-30" },
      { location: "서울 마포구 상수동", minimumPrice: 250000000, auctionDate: "2026-09-15" },
    ],
    imagePrompt: "quiet residential street with multi-family houses in Hapjeong-dong Mapo-gu Seoul Korea, trendy neighborhood with cafes and artistic atmosphere, clean urban village aesthetic, professional real estate photography, warm afternoon sunlight, charming low-rise buildings with character, cozy neighborhood vibe",
    region: "서울",
    imageUrl: "https://img.echotwin.kr/kangstudy/f59038004ebfd21f.jpg",
  },
];

export const awardedRegions = ["전체", "서울", "경기", "인천", "대전", "부산"];
export const awardedPropertyTypes = ["전체", "아파트", "다세대", "오피스텔"];
export const awardedGrades = ["전체", "적극추천", "추천", "관망"];